<template>
  <div class="backToTop">
    <div class="group">
      <i class="iconfont iconweidian" style="font-size:28PX"></i>
      <span>官方群</span>
      <div class="group_qrcode"></div>
    </div>
    <div :class="['top',scrollTop>500?'showTop':'']" @click="onBackToTopClick">
      <i class="iconfont iconweidianji" style="font-size:28PX"></i>
      <span>回顶部</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["scrollTop"],
  methods: {
    onBackToTopClick() {
      this.$emit("backToTop");
    }
  }
};
</script>

<style lang="scss" scoped>
.backToTop {
  position: fixed;
  bottom: 60px;
  right: 40px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  box-shadow: 0px 6px 20px 0px rgba(102, 102, 102, 0.1);
  background: #ffffff;
  z-index: 1;
}
.group,
.top {
  width: 60px;
  height: 60px;
  position: relative;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
    text-align: center;

  i {
    display: block;
    line-height: 36px;
  }
  &:hover {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #435fff;
  }
}
.group {

  .group_qrcode {
    display: none;
    width: 216px;
    height: 283px;
    background-image: url("../../../assets/images/website/group_qrcode.png");
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    left: -212px;
    top: -120px;
  }
  &:hover {
    .group_qrcode {
      display: block;
    }
  }
}
.top {
  display: none;
  span {
    display: none;
  }
  &:hover {
    span {
      display: block;
    }
  }
  &.showTop {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/website/components/backToTop.vue